import Vue from 'vue'
import VueRouter from 'vue-router'
import main from '@/pages/main/main.vue'

import config from '@/utils/config'
import homeFragment from '@/pages/main/fragment/homeFragment'
import teamFragment from '@/pages/main/fragment/teamFragment'
import newsCenterFragment from '@/pages/main/fragment/newsCenterFragment'
import contactUsFragment from '@/pages/main/fragment/ContactUsFragment'
import aboutUsFragment from '@/pages/main/fragment/AboutUsFragment'
import hexinYwFragment from "@/pages/main/fragment/HexinYwFragment";
import anliYjFragment from "@/pages/main/fragment/anliYjFragment";
import newsDetailPage from "@/pages/main/newsDetailPage";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/main',
        meta: {
            title: config.app_name
        }
    },
    {
        path: '/main',
        name: 'main',
        component: main,
        redirect: "home",
        children: [{
            path: "/home",
            name: 'homeFragment',
            component: homeFragment
        }, {
            path: "/team",
            name: 'teamFragment',
            component: teamFragment
        }, {
            path: "/newsCenter",
            name: 'newsCenterFragment',
            component: newsCenterFragment
        }, {
            path: "/contactUs",
            name: 'contactUsFragment',
            component: contactUsFragment
        }, {
            path: "/aboutUs",
            name: 'aboutUsFragment',
            component: aboutUsFragment
        }, {
            path: "/hexinYw",
            name: 'hexinYwFragment',
            component: hexinYwFragment
        }, {
            path: "/anliYj",
            name: 'anliYjFragment',
            component: anliYjFragment
        },
        ]
    }, {
        path: '/newsDetail',
        name: 'newsDetailPage',
        component: newsDetailPage
    },
]

const router = new VueRouter({
    routes,
    mode: 'history',
    // base: '/zwl_r/'
})
export default router
